import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const UpdatesProvider = (props) => {
  const api = new API();
  const [formEditPearls] = Form.useForm();
  const [fetchPearlsList, setFetchPearlsList] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    // subcategory_id: null,
    page: 1,
    limit: 20
  });
  const [loader,setLoader] = useState({
    table: false,
    subdropdown: false,
    subcatdropdown:false,
    add: false,
    edit: false,
    view: false,
    list: false,
    update: false,
    delete: false,
    relatedmcqs: false,
    subjectmcqs: false
  });
  const [viewScreenPearls, setViewScreenPearls] = useState({
    add:false,
    edit:false,
    view:false,
    list:true,
    editsnap:false,
    
  });
  const [subjectDropDown,setSubjectDropDown] = useState([]);
  const [subCategoryDropDown,setSubCategoryDropDown] = useState([]);
  const [pearlsList,setPearlsList] = useState([]);
  const [pearlsSingle,setPearlsSingle] = useState({});
  const [singlePearlsId,setSinglePearlsId] = useState("");
  const [relatedMcqs,setRelatedMcqs] = useState([]);
  const [relatedSubject,setRelatedSubject] = useState([]);
  const [selectSubject,setSelectSubject] = useState([]);
  const [addPearlsForm,setAddPearlsForm] = useState({
    question_name: "",
    question_description: "",
  })
  const [appSettings,setAppSettings] = useState({});
  const [appSettingsLoading,setAppSettingsLoading] = useState(false);
  const [appSettingsULoading,setAppSettingsULoading] = useState(false);
  const [updateName,setUpdateName] = useState("");
  const [updatesCatLoader, setUpdatesCatLoader] = useState(false);
  const [updatesCatList, setUpdatesCatList] = useState([]);
  const [updatesCatTableFilter, setUpdatesCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [updatesSubCatLoader, setUpdatesSubCatLoader] = useState(false);
  const [updatesSubCatList, setUpdatesSubCatList] = useState([]);
  const [updatesSubCatTableFilter, setUpdatesSubCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [bulkActionUpdatesExam, setBulkActionUpdatesExam] = useState([]);
  const [bulkActionUpdatesExamLoader, setBulkActionUpdatesExamLoader] = useState(false);
  const [bulkActionUpdatesType, setBulkActionUpdatesType] = useState(false);
  const fetchUpdatesSubCatList = async (id) => {
    setUpdatesSubCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/subcategorylist/list", { ...updatesSubCatTableFilter, id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setUpdatesSubCatList(res?.data?.data);
          setUpdatesSubCatLoader(false);
        } else {
          setUpdatesSubCatList([]);
          setUpdatesSubCatLoader(false);
        }
      });
  }
  const fetchUpdatesCatList = async () => {
    setUpdatesCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("updates/categorylist/list", { ...updatesCatTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setUpdatesCatList(res?.data?.data);
          setUpdatesCatLoader(false);
        } else {
          setUpdatesCatList([]);
          setUpdatesCatLoader(false);
        }
      });
  }
  const getAppSettings = async () => {
    if (localStorage.getItem("rxdx_admin_login") === "true") {
      setAppSettingsLoading(true);
      try {
        const res = await api.getAll("updates/appsettings", {});
        if (res?.data?.status === 200) {
          setAppSettings(res?.data?.data);
          setUpdateName(res?.data?.data?.updates_name);
        } else {
          setAppSettings({});
        }
      } catch (err) {
        setAppSettings({});
      } finally {
        setAppSettingsLoading(false);
      }
    }
  }  
  const updateAppSettings = async (updates_name) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setAppSettingsULoading(false);
      (await api.create("updates/appsettings", {
        updates_name:updates_name
      }, (err, res) => {
        if (res?.data?.status === 200) {
          getAppSettings();
          setAppSettingsULoading(false);
        } else {
          setAppSettingsULoading(false);
        }
      }));
  }
  const fetchPearlsTable = async (id,cid) => {
    setLoader({
      ...loader,
      table: true
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updates/subjectwise", { ...tableFilter,subcategory_id:id,category_id:cid }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchPearlsList(res?.data?.data);
        } else {
          setFetchPearlsList([]);
        }
        setLoader({
          ...loader,
          table: false
        });
      }));
  };

  const loadSSubjectDropdown = async () => {
    setLoader({
      ...loader,
      subdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("subjectmaster/dropdown", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubjectDropDown(res?.data?.data);
        } else {
          setSubjectDropDown([]);
        }
        setLoader({
          ...loader,
          subdropdown: false
        })
      }))
  }

  const loadSubCategoryDropdown = async () => {
    setLoader({
      ...loader,
      subcatdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("categorymaster/dropdownsub", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubCategoryDropDown(res?.data?.data);
        } else {
          setSubCategoryDropDown([]);
        }
        setLoader({
          ...loader,
          subcatdropdown: false
        })
      }))
  }

  const addNewPearls = async (data,scid,sid,resetAdd,tid,callback=null) => {
    setLoader({
      ...loader,
      add: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("subject_id", sid);
    formData.append("topic_id", tid);
    formData.append("subcategory_id", scid);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("updates", formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setAddPearlsForm({
            question_name: "",
            question_description: "",
          })
          resetAdd();
          // getPearlsAll(scid,sid);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", res?.response?.data?.message);
        }
        setLoader({
          ...loader,
          add: false
        })
      }))
  }

  const getPearlsAll = async (tid, page = 1, limit = 120) => {
    setLoader({
      ...loader,
      list: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updates/updates_notes_list_v2", {topic_id: tid, page: page, limit: limit}, (err, res) => {
        if(res?.data?.status === 200) {
          setPearlsList(res?.data?.data);
        } else {
          setPearlsList([]);
        }
        setLoader({
          ...loader,
          list: false
        })
      }))
  }

  const getSinglePearls = async (id) => {
    setViewScreenPearls({
      ...viewScreenPearls,
      list: false,
      add: false,
      view: true
    })
    setLoader({
      ...loader,
      view: true
    })
    formEditPearls.resetFields();
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle("updates/single", id, (err, res) => {
        if(res?.data?.status === 200) {
          fetchRelatedMcqs(res?.data?.data?.tag_subject);
          setPearlsSingle(res?.data?.data);
          setSinglePearlsId(res?.data?.data?._id);
          formEditPearls.setFieldsValue(res?.data?.data);
        } else {
          setPearlsSingle({});
        }
        setLoader({
          ...loader,
          view: false
        })
      }))
  }

  const updatePearls = async (data, id, scid, sid, resetEdit,tid,callback=null) => {
    setLoader({
      ...loader,
      update: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("topic_id", tid);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      // (await api.update("updates", id, formData, (err, res) => {
        (await api.update("duplicate/updatesupdate", id, formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          resetEdit();
          // getPearlsAll(scid, sid);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", res?.response?.data?.message);
        }
        setLoader({
          ...loader,
          update: false
        })
      }))
  }

  const deletePearls = async (id, scid, sid,callback=null) => {
    setLoader({
      ...loader,
      delete: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("updates", id, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setViewScreenPearls({
            ...viewScreenPearls,  
            add: false,
            view: false,
            edit: false,
            update: false,
            list: true,
          })
          // getPearlsAll(scid, sid);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          delete: false
        })
      }))
  }

  const scrollToTopViewPearls = (id) => {
    document.getElementById(`question_order_${id}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }

  const fetchRelatedSubject = async () => {
    setLoader({
      ...loader,
      subjectmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updates/subjectlist",{}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedSubject(res?.data?.data);
        } else {
          setRelatedSubject([]);
        }
        setLoader({
          ...loader,
          subjectmcqs: false
        })
      }))
  }
  function dangerouslySetInnerHTMLToText(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  const fetchRelatedMcqs = async (e) => {
    setRelatedMcqs([]);
    setLoader({
      ...loader,
      relatedmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updates/questiontag", {subject_id: e}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedMcqs(
            (res?.data?.data ?? []).map((mcq) => ({
              value: mcq?.value,
              label: mcq.label ? (
                dangerouslySetInnerHTMLToText(mcq.label)
              ) : null
            }))
          );
          
        } else {
          setRelatedMcqs([]);
        }
        setLoader({
          ...loader,
          relatedmcqs: false
        })
      }))
  }

  const bulkActionUpdates = async (ids = [], action = null,scid=null, sid=null,callback=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionUpdatesExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action_updates", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          // scid && sid && getPearlsAll(scid, sid);
          callback && callback(err, res);
          setBulkActionUpdatesExam([]);
          setBulkActionUpdatesExamLoader(false);
        } else {
          setBulkActionUpdatesExamLoader(false);
        }
      });
  }

   return (
    <Context.Provider value={{
      ...props,
      fetchPearlsList,
      fetchPearlsTable,
      setFetchPearlsList,
      tableFilter,
      setTableFilter,
      loader,
      subjectDropDown,
      loadSSubjectDropdown,
      loadSubCategoryDropdown,
      subCategoryDropDown,
      addPearlsForm,
      setAddPearlsForm,
      addNewPearls,
      viewScreenPearls,
      setViewScreenPearls,
      getPearlsAll,
      setPearlsList,
      pearlsList,
      getSinglePearls,
      pearlsSingle,
      setPearlsSingle,
      formEditPearls,
      singlePearlsId,
      setSinglePearlsId,
      updatePearls,
      deletePearls,
      scrollToTopViewPearls,
      fetchRelatedMcqs,
      relatedMcqs,
      relatedSubject,
      setRelatedSubject,
      fetchRelatedSubject,
      selectSubject,
      setSelectSubject,
      appSettings,setAppSettings,
      appSettingsLoading,setAppSettingsLoading,
      appSettingsULoading,setAppSettingsULoading,
      updateAppSettings,
      getAppSettings,
      updateName,setUpdateName,
      fetchUpdatesCatList,
      updatesCatLoader, setUpdatesCatLoader,
      updatesCatList, setUpdatesCatList,
      updatesCatTableFilter, setUpdatesCatTableFilter,
      fetchUpdatesSubCatList,
      updatesSubCatLoader, setUpdatesSubCatLoader,
      updatesSubCatList, setUpdatesSubCatList,
      updatesSubCatTableFilter, setUpdatesSubCatTableFilter,
      bulkActionUpdates,
        bulkActionUpdatesExam, setBulkActionUpdatesExam,
        bulkActionUpdatesExamLoader, setBulkActionUpdatesExamLoader,
        bulkActionUpdatesType, setBulkActionUpdatesType,
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default UpdatesProvider;